<template>
  <div class="tree-list layout-row" @click="hideMenu" v-loading="loading">
    <div class="mask-disable-drag" :class="`sortable-disable-${categoryId}`"></div>
    <!-- 左侧树 -->
    <div class="lib-tree position-relative">
      <div class="lib-tree-body">
        <el-tree
            :props="defaultProps"
            :data="treeData"
            node-key="TreeID"
            ref="tree"
            :auto-expand-parent="true"
            :default-expanded-keys="defaultExpandedKeys"
            :current-node-key="currentKey"
            :highlight-current="true"
            :expand-on-click-node="false"
            :load="loadTree"
            :lazy="lazy"
            @current-change="handleNodeChange"
            @node-contextmenu="handleMenuToggle"
        >
          <div class="custom-tree-node" slot-scope="{ node, data }">
            <span v-html='getIcon(node)' class="tree-icon"></span>
            <span class="tree-span" :data-drag="data.hasOwnProperty('drag') ? 0 : 1" :data-parentid='data.ParentID' :data-id="data.DirID" :data-is-share="data.isShare" :data-owner="data.Owner"
                :data-parent-id-path="data.ParentIDPath" :data-category="categoryId" :data-dircategory="categoryId">{{ node.label }}</span>
            <span class="data-count" v-if="data.DirID > 0">({{data.DataCount}})</span>
            <!-- <span class="sort-btns" v-if="sortable && data.DirID > 0">
              <i class="el-icon-upload2" @click.stop="sortDir('up',data)" />
              <i class="el-icon-download" @click.stop="sortDir('down',data)" />
            </span> -->
            <div class="md-tree-add-icon" @click.stop="handleMenuToggle($event,data)" v-if="data.DirID === 0 && isEdit && data.DirName != '自有装备管理'">+</div>
          </div>
        </el-tree>

      </div>
      <context-menu :menus="menus" v-show="showMenu" ref="contextMenu" @menuClick="menuClick"/>
    </div>
    <tree-edit
        ref="treeEdit"
        :activeTreeNode="choosedDir"
        :categoryId="categoryId"
        @del-success="delNode"
        @insert-success="insertNode"
        @modify-success="modifyNode"
    ></tree-edit>
  </div>
</template>

<script>
import {CheckLibs} from '@digital-supply-chain/module'
import {Category} from '@/libs/category';
import {TreeService, DataService, UserService, DragService} from "@/service";
import {ApiService, Listener, UtilService} from "@/libs";

// 组件相关方法
import {ShareaCategorys} from './dir-tree'

//引入组件
import TreeEdit from "./tree-edit";
import ContextMenu from "./context-menu";
import { WinForm } from "@digital-supply-chain/module";

  export default {
    name: "tree-list",
    props: {
      compID: { default: '' },
      lazy: { default: true },
      categoryType: {
        type: String,
        default: ""
      },
      defaultNode: {
        type: Array,
        default: [{DirName: "目录", DirID: 0, TreeID: 'list_0', IsLeaf: false}]
      },
      defaultExpandedKeys: {
        type: Array,
        default() {
          return [];
        }
      },
      sortable: Boolean,
      currentKey: {
        type: String,
        default: ''
      }
    },
    components: {TreeEdit, ContextMenu},
    data() {
      return {
        treeData: [], // props lazy为true时生效
        shareAreaObj: {},
        defaultProps: {
          children: "children",
          label: "DirName",
          isLeaf: "IsLeaf"
        },
        choosedDir: {}, //右键编辑的树
        categoryId: Category[this.categoryType],
        loginUserId: UserService.userID(),
        CompID: UserService.compId(),
        breadcrumbData: [this.defaultNode[0]],//面包屑
        showMenu: false,
        menus: [],
        myTreeNode: null,
        currentNodeData: {},
        isManager: false,
        curNode: null,

        loading: false,
      };
    },
    created() {
      // 组件初始化
      this.$nextTick(() => {
        this.currentNodeData = this.$refs.tree.getCurrentNode()
        this.curNode = this.$refs.tree.getNode(this.currentKey);
      })
    },
    mounted() {
      Listener.bodyEventDelegate([], 'el-tree-node', (value) => {
        value.type === "out_click" && (this.hideMenu())
      })

      !this.lazy && (this.getTreeData());

      // 监听数量更新事件
      this.$root.$on('updateTreeCount', this.handleUpdateCount);

      // 监听授权数据修改
      WinForm.md.$on(`toggleRowAuth_${this.categoryId}`, (data) => {
        const {Datas = [], authedLen = 0} = data;
        Datas.forEach(item => {
          this.shareAreaObj[item.DataID] = authedLen > 0 ? 1 : 0;
        })
      })
    },
    beforeDestroy() {
      // 清理事件监听
      this.$root.$off('updateTreeCount', this.handleUpdateCount);
    },
    methods: {
      // 处理数量更新
      handleUpdateCount({ dirId, categoryId, increment }) {
        if (this.categoryId == categoryId) {
          // 找到对应的目录节点并更新数量
          this.updateNodeCount(dirId, increment);
        }
      },
      // 更新节点数量
      updateNodeCount(dirId, increment) {
        const updateNodeData = (nodes) => {
          nodes.forEach(node => {
            if (node.data && node.data.DirID == dirId) {
              node.data.DataCount = (node.data.DataCount || 0) + increment;
            }
            if (node.childNodes && node.childNodes.length > 0) {
              updateNodeData(node.childNodes);
            }
          });
        };
        
        // 更新 treeData
        updateNodeData(this.treeData);
        
        // 如果当前有展开的节点，也需要更新
        if (this.$refs.tree) {
          const allNodes = this.$refs.tree.store.nodesMap;
          Object.values(allNodes).forEach(node => {
            if (node.data && node.data.DirID == dirId) {
              node.data.DataCount = (node.data.DataCount || 0) + increment;
            }
          });
        }
      },
      // tree组件自带方法调用
      // 取消当前高亮的节点
      setCurrentNull() {
        this.$refs.tree.setCurrentKey(null);
      },

      // lazy为false时
      async getTreeData() {
        this.loading = true;
        if (this.categoryId === Category.ProdDir) {
          let data = await TreeService.getProddirList2(this.compID, 0, 1);
          this.loading = false;
          if (data) {
            const treeDataValue = this.defaultNode[0];
            this.treeData = [{
              ...treeDataValue,
              children: UtilService.getTreeData(data, 0, 'ParentID', 'DirID')
            }]
          }
        }

        // 目录树加载完成之后，如果存在默认选中的值则滚动条自动滚到到位置，并触发一次选中事件
        this.$nextTick(() => {
          const firstFocus = document.querySelector('.is-current');
          const parentDom = document.querySelector('.el-tree');
          if (firstFocus && parentDom) {
            parentDom.scrollTop = firstFocus.offsetTop - 100;
            this.select(this.currentKey);
          }
        })
        
      },

      sortDir(type,data) {
        const tree = TreeService.tree[this.categoryId][data.ParentID];
        let index = tree.findIndex(item=>item.DirID === data.DirID);
        let base = 0;
        if(type==="up"){
          if(index === 0) return;
          base = index-1;
          this.$refs.tree.remove(data);
          this.$refs.tree.insertBefore(data, tree[base]);
        } else {
          if(index+1 === tree.length) return;
          base = index+1;
          this.$refs.tree.remove(data);
          this.$refs.tree.insertAfter(data, tree[base]);
        }
        tree.splice(base, 0, ...tree.splice(index, 1));
        DataService.post(`${ApiService.JrzzApi}/sort/${this.categoryId}/save`,tree.map(item=>item.DirID)).then(res=>{

        });
      },
      //获取树
      async loadTree(node, resolve) {
        if (node.level == 0) {
          resolve(this.defaultNode);
        }
        if(node.data && node.data.isfixed){
           return resolve(node.data.children);
        }

        // if (node.level > 0 && this.categoryId === Category.ProdDir) {
          // let data = await TreeService.getProddirList2(this.compID, node.data.DirID, 0);
          // resolve(data);
          // this.initTreeDrag();
          // return;
        // }

        if(node.data && (node.data.DirID == -21 || node.data.DirID == -22)){
          let type = node.data.DirID == -21 ? 1 : 2;
          let data = await TreeService.getProdClasses(type);
          data.forEach(item=>{
            item.drag = false;
          })
          resolve(data);
          this.initTreeDrag();
          return ;
        }
        if (node.level > 0) {
          const query = this.sortable ? "&orderBy=sortindex asc" : "";
          var data = await TreeService.get(node.data.DirID, this.categoryId, node.data, query);
          // 设置目录数据是否授权
          (data || []).forEach(item => {
            this.$set(this.shareAreaObj,item.DirID,item.ShareArea);
          })

          resolve(data);
          if (node.data.DirID == this.currentKey) {
            this.curNode = this.$refs.tree.getNode(this.currentKey);
          }
          this.initTreeDrag();
        }
      },
      //新增一个节点
      insertNode(data) {
        data.Owner = this.loginUserId;
        data.OwnerComp =   this.CompID;
        data.DataCount = 0;
        let parentsArr = this.getAllChildrenByID(data.pid);
        let parentData = parentsArr[0].data;
        let ParentIDPath = data.ParentIDPath ? 
          `${data.ParentIDPath}${data.pid}L` : 
          `${parentData.ParentIDPath ? parentData.ParentIDPath+parentData.DirID+'L' : parentData.DirID+'L'}`;
        let obj = {Owner: Number(this.loginUserId), IsLeaf: true, ParentIDPath};
        parentsArr.forEach(parent => {
          let nodeData;
          if (parent.data.DirID.toString().startsWith("shared_")) {
            nodeData = Object.assign(
                {isShare: 1, TreeID: `shared_${data.DirID}`},
                data,
                obj
            );
          } else {
            nodeData = Object.assign({TreeID: `list_${data.DirID}`}, data, obj);
          }
          this.appendNode(nodeData, parent);
        });
      },
      addSubDir() {
        this.choosedDir = this.currentNodeData;
        this.$nextTick(() => {
          this.$refs.treeEdit.btnHandler({type: "add", name: "新增子目录"});
        })
      },
      //删除一个节点
      delNode(data) {
        this.setCurNode(); // 顺序在remove前面，否则会找不到node
        this.choosedDir.DataCount > 0 && this.dataCountCalc({
                incNode: {data: {}},
                decNode: {data: this.choosedDir},
                dataCount: this.choosedDir.DataCount,
                isData: true,
              })
        this.removeNode(data.DirID, true);
      },
      //修改节点
      modifyNode(data) {
        let curnode = this.getAllChildrenByID(data.DirID)
        curnode.forEach(node => {
          //更新节点名称
          node.data.DirName = data.DirName;
          node.data.DirRemark = data.DirRemark;
          node.data.ShareArea = data.ShareArea;
          node.data.CategoryID = data.CategoryID;
        });
      },
      getTree(data, index = false) {
        let pid = this.breadcrumbData[this.breadcrumbData.length - 1].DirID;
        let tree = TreeService.tree[this.categoryId][pid];
        if (!index) {
          return tree;
        } else {
          let index = tree.findIndex(item => item.DirID == data.DirID);
          return tree[index];
        }
      },
      // 添加目录
      appendNode(fromData, toNode) {
        toNode.data.IsLeaf = false;
        if (toNode.loaded) {
          // 已经展开过 append节点
          this.$refs.tree.append(fromData, toNode.data);
          toNode.expand();
        } else {
          toNode.expand(); // 未展开过 直接展开
        }
        const tree = TreeService.tree[this.categoryId][toNode.data.DirID];
        tree.push(fromData);
        this.initTreeDrag();
      },
      // 移除目录
      removeNode(deleID, isDelAll) {
        let deleNodes = this.getAllChildrenByID(deleID);
        const parentId = deleNodes[0].parent.data.DirID
        let parentsArr = this.getAllChildrenByID(parentId);

        for (let i = 0; i < deleNodes.length; i++) {
          const node = deleNodes[i];
          if (!isDelAll && node.data.TreeID.toString().startsWith("shared_auth_"))
            continue;
          this.$refs.tree.remove(node); // 不是团队第一层的都删除；
        }

        // 节点children数量相同，没有打开过的children长度是0,需要从打开过判断长度；
        let isNotEmpty = parentsArr.some(pnode => pnode.childNodes.length > 0);
        if (!isNotEmpty) {
          parentsArr.forEach(pnode => {
            pnode.expanded = false;
            pnode.data.IsLeaf = true;
            pnode.isLeaf = true;
          });
        }
        const tree = TreeService.tree[this.categoryId][parentId];
        const index = tree.findIndex(item=>item.DirID === deleID)
        tree.splice(index,1);
        this.initTreeDrag();
      },
      // 设置当前选中treenode;
      setCurNode() {
        var curData = this.$refs.tree.getCurrentNode();
        let chosNode = this.$refs.tree.getNode(this.choosedDir.TreeID);
        if (!chosNode) return;
        let curPath = curData.ParentIDPath || `${curData.DirID}L`;
        let chosPath = chosNode.data.ParentIDPath;
        if (![0, -1].includes(curData.TreeID) && curPath.startsWith(chosPath)) { // 当先选中为跟目录的不操作；选中节点在操作节点下级才设置
          let isEquelNode = curData.TreeID == chosNode.data.TreeID
          if (curPath.indexOf(chosNode.data.DirID.toString()) == -1 && !isEquelNode) {
            return;  // 排除父级的同级节点（path相同） 和 当前节点（当前节点ID不再path上）
          }
          if (curPath.length > chosPath.length || isEquelNode) { // 如果当前选中的在删除node的下级，或者节点相同
            //更新选中节点(选中它的父级)
            let parentNode = chosNode.parent
            this.$refs.tree.setCurrentKey(parentNode.data.TreeID);
            this.currentNodeData = parentNode.data;
            this.curNode = parentNode;
          }
        }
      },
      // 拖拽数据后计算DataCount
      dragDataCallback(params) {
        let incNode;
        incNode = this.getAllChildrenByID(params.toId)[0];
        let decNode = this.getAllChildrenByID(params.fromId)[0];
        params.row && (params.row.MoveToDirID = params.toId);
        this.dataCountCalc({incNode, decNode, dataCount: 1, isData: true, toPath:params.toPath });
      },
      dataCountCalc({incNode, decNode, dataCount, isData, toPath}){
        if(dataCount == 0) {
          return false;
        }
        let incNodeParentIdPath = '';
        let incNodeParents = [];
        if(incNode) {
          incNodeParentIdPath = toPath ? toPath : incNode.data.ParentIDPath;
          incNodeParents = incNodeParentIdPath ? incNodeParentIdPath.split('L') : [];
          incNodeParents.pop();
          incNodeParents.shift();
          incNode && incNode.data.hasOwnProperty('DirID') && incNodeParents.push(incNode.data.DirID)
        }
        let decNodeParentIdPath = decNode.data ? decNode.data.ParentIDPath : '';
        let decNodeParents = decNodeParentIdPath ? decNodeParentIdPath.split('L') : [];
        decNodeParents.pop();
        decNodeParents.shift();
        isData && decNode && decNode.data && decNodeParents.push(decNode.data.DirID);
        for( var i=0; i++; i < incNodeParents.length ) {
          if(incNodeParents[i] != decNodeParents[i]) {
            if(i > 0) {
              incNodeParents.splice(i);
              decNodeParents.splice(i);
            }
            break;
          }
        }
        incNodeParents.forEach(id=>{
          let nodes = this.getAllChildrenByID(id);
          nodes.forEach(node=>{
            node && (node.data.DataCount += dataCount)
          })
        })
        decNodeParents.forEach(id=>{
          let nodes = this.getAllChildrenByID(id);
          nodes.forEach(node=>{
            node && (node.data.DataCount -= dataCount)
          })
        })
      },
      select(treeID) {
        this.$refs.tree.setCurrentKey(treeID);
        let chosNode = this.$refs.tree.getNode(treeID);
        this.dirChanged(chosNode.data, chosNode);
        this.currentNodeData = chosNode.data;
        this.breadcrumbData = [chosNode.data];
        this.curNode = chosNode;
      },
      //点击树节点
      handleNodeChange(data, node, isBack) {
        this.hideMenu();
        if(!node.isLeaf) node.expand();// 加载过后折叠后再点击还是能后打开
        if (this.currentNodeData && data.TreeID === this.currentNodeData.TreeID) {
          this.dirChanged(data, node, true);
          return false;
        };
        data.pid = node.parent.data && node.parent.data.DirID;
        this.dirChanged(data, node, false);
        this.currentNodeData = data;
        this.breadcrumbData = [data];
        this.curNode = node;
      },
      // //隐藏右键菜单
      hideMenu() {
        this.showMenu = false;
      },
      //展示右键菜单
      handleMenuToggle(event, data, node) {
        if(data.DirName == '自有装备管理') {
          return
        }
        // 部分情况下不可编辑目录
        if ([Category.ProdDir].includes(this.categoryId)) {
          return;
        }

        if (data && data.TreeID.startsWith('list_') && ( data.DirID > 0 || data.DirID == 0 ) ) {
          this.showMenu = true;
          let menusData = [];
          if (data.DirID) {
            menusData = [
              {name: "新增子目录", type: "add"},
              {name: "修改", type: "modify"},
              {name: "授权", type: "grant"},
              {type: "divider"},
              {name: "删除", type: "del"},
            ];

            // 判断是否显示授权按钮
            if (!ShareaCategorys.includes(Number(this.categoryId))) {
              menusData = menusData.filter(item => item.type != 'grant');
            }

            const isEntClient = CheckLibs.isBigEngineerE() || CheckLibs.isGreatCraftsmanEnt();
            if (!isEntClient) {
              menusData = menusData.filter(item => item.type != 'grant');
            }

          } else {
            menusData = [{name: "新增子目录", type: "add"}];
          }
          this.menus = menusData;
          this.choosedDir = data; //获取当前编辑对象
          this.$refs.contextMenu.changePosition(event.clientX, event.clientY);
        }
      },
      //点击右键菜单
      menuClick(menu) {
        this.$refs.treeEdit.btnHandler(menu);
      },
      //节点发生变化
      dirChanged(dir, node = {}, isNow = false) {
        this.$emit("dirChanged", dir, node, isNow);
      },
      //获取当前节点所有父节点
      getParentTreeNode(data, parentArr) {
        !parentArr && (parentArr = []);
        parentArr.unshift(data);
        if (data.DirID != 0) {
          let parentNode = this.$refs.tree.getNode(data.DirID).parent;
          this.getParentTreeNode(parentNode.data, parentArr);
        }
        return parentArr;
      },
      // 获取所有子节点（dirID）
      getAllChildrenByID(dirID, parentNode = this.$refs.tree.root, nodeArr) {
        if (!nodeArr) nodeArr = [];
        if (parentNode.data && parentNode.data.DirID == dirID)
          nodeArr.push(parentNode);
        if (parentNode.childNodes.length > 0) {
          parentNode.childNodes.forEach(node => {
            this.getAllChildrenByID(dirID, node, nodeArr);
          });
        }
        return nodeArr;
      },

      initTreeDrag() {
        setTimeout(() => {
          DragService.dragTree(this.dragCallback, this.categoryId);
        }, 300);
      },
      dragCallback(ids, calc = true) {
        let parentNodes = this.getAllChildrenByID(ids.toId);
        let fromNodes = this.getAllChildrenByID(ids.fromId);
        let toNodeData = parentNodes[0]?.data;
        if (!toNodeData) {
          this.initTreeDrag();
          return false;
        }
        let ParentIDPath = toNodeData.ParentIDPath
            ? `${toNodeData.ParentIDPath}${toNodeData.DirID}L`
            : `${toNodeData.DirID}L`;
        calc && this.dataCountCalc({incNode:parentNodes[0], decNode:fromNodes[0], dataCount: fromNodes[0].data.DataCount, isData: false})
        this.removeNode(ids.fromId, false); // 先删除后添加
        parentNodes && parentNodes.forEach(parent => {
          let data = Object.assign({}, fromNodes[0].data);
          data.ParentIDPath = ParentIDPath;
          if (parent.data.TreeID.toString().startsWith("shared_")) {
            data.TreeID = `shared_${ids.fromId}`;
            data.isShare = 1;
          } else {
            delete data.isShare;
            data.TreeID = `list_${ids.fromId}`;
          }
          this.appendNode(data, parent);
        });
        this.initTreeDrag();
      },

      // 计算属性
      getIcon(node) {
        if (this.categoryId === Category.ProdDir) {
          return `<img src='${require('../../assets/images/tree/dir.png')}'/>`;
        }
        if (this.shareAreaObj[node.data.DirID]) {
          return `<img src='${require('../../assets/images/tree/dirShare.png')}'/>`
        } else if (node.data.DirID > 0) {
          return `<img src='${require('../../assets/images/tree/dir.png')}'/>`
        } else if (node.data.DirID == -1) {
          return `<img src='${require('../../assets/images/tree/typeAuth.png')}'/>`
        } else if (node.data.DirID == 0 && this.categoryType.includes('Share')) {
          return `<img src='${require('../../assets/images/tree/typeShare.png')}'/>`
        } else {
          return `<img src='${require('../../assets/images/tree/dir0.png')}'/>`
        }
      },
    },
    computed: {
      isEdit() {
        return ![Category.ProdDir].includes(this.categoryId);
      }
    },
  };
</script>

<style scoped lang="less">
.mask-disable-drag{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 9;
  background: #ffffff;
  opacity: 0.5;
  cursor: no-drop;
  display: none;
}
.tree-list{
  position: relative;
}

  // 左侧分类树
  .lib-tree {
    width: 100%;
    height: 100%;
  }

  .tree-icon{
    width: 15px;
    height: 13px;
    font-size: 0;
    display: inline-block;
    vertical-align: middle;
    /deep/ img{
      width: 100%;
      height: 100%;
      margin-top: -1px;
    }
  }

  .lib-tree-body {
    overflow: hidden;
    cursor: auto;
    display: flex;
    flex-direction: column;
    .el-tree{
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: auto;
      font-size: 14px;
    }

    &:hover {
      overflow-y: overlay;
    }
  }
  
  .custom-tree-node {
    width: 100%;
    user-select: none;
    line-height: 1;
    -webkit-user-select: none;
    position: relative;
    .iconfont {
      color: #c5c5c5;
      font-size: 12px;
      padding: 2px 0;
      &:hover{
        color: dodgerblue;
        background-color: #e4e4e4;
      }
    }

    .tree-span {
      color: #606672;
      padding-left: 6px;
    }

    .data-count{
      margin-right: 10px;
      color: #999;
    }
  }

  /deep/ .el-tree-node.is-current > .el-tree-node__content > .custom-tree-node .tree-span{
    color: #0989C5;
  }
  /deep/ .el-tree-node.is-current > .el-tree-node__content > .custom-tree-node .data-count{
    color: #0989C5;
  }

  /deep/ .el-tree-node__expand-icon {
    color: #666;
  }
  /deep/ .el-tree-node.is-current > .el-tree-node__content .el-tree-node__expand-icon{
    color: #0989C5;
  }

  /deep/ .el-tree-node__expand-icon.is-leaf {
    color: transparent!important;
  }

  /deep/ .el-tree-node.is-current > .el-tree-node__content {
    background-color: #e6f3f9;
  }

  /deep/ .el-tree-node__content {
    line-height: 30px;
    height: 30px;
  }

  /deep/ .el-tree {
    .el-tree-node {
      .forbid {
        cursor: not-allowed;
      }
    }
  }

  .md-tree-add-icon{
    position: absolute;
    right: 12px;
    top: 0;
    width: 16px;
    height: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid #606672;
    color: #606672;
  }
</style>
